import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar } from 'react-icons/fa';

function Success() {
  return (
    <div className="success-section">
      <Helmet>
        <title>Bestellung erfolgreich - Lackfertighaus</title>
        <meta name="description" content="Ihre Bestellung wurde erfolgreich aufgegeben" />
        <link rel="canonical" href="https://lackfertighaus.com/success" />
      </Helmet>

      <div className="success-content">
        <div className="success-icon">
          <FaStar />
        </div>
        <h1>Vielen Dank für Ihre Bestellung!</h1>
        <p>
          Ihre Bestellung wurde erfolgreich aufgegeben und wird in Kürze bearbeitet. 
          Sie erhalten eine Bestätigungs-E-Mail mit allen Details zu Ihrer Bestellung.
        </p>
        <p>
          Unser Team wird sich zeitnah mit Ihnen in Verbindung setzen, um die weiteren 
          Schritte zu besprechen und die Lieferung zu koordinieren.
        </p>
        <Link to="/" className="btn-primary">
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}

export default Success;